import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Avatar from '../../Assetes/Images/avatar.svg';
import IconButton from '@mui/material/IconButton';
import { connect, useSelector } from 'react-redux';
import { editProfileverifyOtp, sendOtp, updateProfileData, saveCustomerInfo, getConsentConfig } from "../../Redux/actions/customer"
import { toast } from 'react-toastify';
import { IMAGE_URL, BASE_URL } from '../../Components/client-config';
import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import Header from '../../Components/Header';
import { useHistory } from 'react-router-dom';
import GoBack from '../BackButton/GoBack';
import OtpModal from '../Cart/OtpModal';
import { Modal } from 'react-bootstrap';
import jwtDecode from 'jwt-decode';
import { getProfile } from '../../Redux';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { checkPhone, MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';
import Footer from '../../Components/Footer';
import { ConsentCheckboxesProfile } from '../../Components/ConsentCheckboxes';
import type { ConsentConfig } from '../../Components/ConsentCheckboxes';
import type { ConsentKey } from '../../lib/constants';
import Api from '../../Components/Api';
var CryptoJS = require("crypto-js");

function MyDetail(props: any) {
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const { updateProfileData } = props;
    const userInfo = useSelector((state: any) => state.customer.userInfo);
    const phone = userInfo?.phone_number;
    const [profilePic, setProfilePic] = useState<File | string | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null)
    const [first_name, setFirst_name] = useState(userInfo?.first_name)
    const [email_address, setEmail_address] = useState(userInfo?.email_address)
    const [phone_number, setPhone_number] = useState("")
    const customer_id = userInfo?.customer_id
    const [phoneError, setPhoneError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [disableBtn, setDisableBtn] = useState(true);
    const [gender, setGender] = useState(userInfo?.gender)
    const [date, setDate] = useState('')
    const [first_nameDisable, setFirst_nameDisable] = useState(false);
    const [genderDisable, setGenderDisable] = useState(false);
    const [phoneDisable, setPhoneDisable] = useState(true);
    const [dateDisable, setDateDisable] = useState(false);
    const history = useHistory();
    const today: any = new Date().toISOString().split('T')[0];
    const check_number = phone?.substring(1)
    const [otp, setOtp] = useState("");
    const [show, setShow] = useState(false);
    const [verifyDisable, setVerifyDisable] = useState(true);
    const [consentValues, setConsentValues] = useState<Partial<Record<ConsentKey, number>>>({
        send_email: 0,
        send_pn: 0,
        send_sms: 0,
        check_policy: 0,
    });
    const [consentConfig, setConsentConfig] = useState<ConsentConfig>({});
    const isActive = userInfo?.is_active;
    const lang = useCurrentLocale();
    const { t } = useTranslation();


    useEffect(() => {
        if (userInfo?.profile_pic) {
            setProfilePic(userInfo.profile_pic);
        }
    }, [userInfo?.profile_pic]);
    useEffect(() => {
        let token = localStorage.getItem("userToken");
        if (token) {
            let userData: any = jwtDecode(token);
                props.saveCustomerInfo();
                props.getProfile(userData.customer.customer_id)

        }
    }, [])
    useEffect(() => {
        if (!isLogged) {
            toast.error(t("LOGIN_FIRST_PROFILE"));
            history.push(`/${lang}/menu`);
        }
        const formattedPhoneNumber = phone?.split("-")[1];
        checkPhone(formattedPhoneNumber) ? setPhone_number(formattedPhoneNumber) : setPhone_number("")
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        props.getConsentConfig(lang)
            .then((c: ConsentConfig) => {
                setConsentConfig(c);
            })
            .catch(() => setConsentConfig({}));
    }, [lang]);
    useEffect(() => {
        if (userInfo && Object.keys(userInfo).length > 0) {
            if (userInfo.first_name) {
                setFirst_name(userInfo.first_name);
            }
            if (userInfo.email_address) {
                setEmail_address(userInfo.email_address);
            }
            if (userInfo.gender) {
                setGender(userInfo.gender);
            }
            if (userInfo.phone_number) {
                const formattedPhoneNumber = userInfo.phone_number.split("-")[1];
                if (checkPhone(formattedPhoneNumber)) {
                    setPhone_number(formattedPhoneNumber);
                }
            }
            if (userInfo.customer_birthday) {
                try {
                    const dob = new Date(userInfo.customer_birthday).toISOString()?.slice(0, 10);
                    setDate(dob);
                } catch (err) {
                }
            }
        }
    }, [userInfo]);

    useEffect(() => {
        const keys: ConsentKey[] = ['send_email', 'send_pn', 'send_sms', 'check_policy'];
        const next: Partial<Record<ConsentKey, number>> = {};

        keys.forEach((key) => {
            let customerValue: number | undefined;
            switch (key) {
                case 'send_email':
                    customerValue = (userInfo as any)?.send_email;
                    break;
                case 'send_pn':
                    customerValue = (userInfo as any)?.send_pn;
                    break;
                case 'send_sms':
                    customerValue = (userInfo as any)?.send_sms;
                    break;
                case 'check_policy':
                    customerValue = (userInfo as any)?.check_policy;
                    break;
            }

            if (typeof customerValue !== 'undefined' && customerValue !== null) {
                next[key] = customerValue ? 1 : 0;
            } else if (consentConfig[key]?.preChecked) {
                next[key] = 1;
            } else {
                next[key] = 0;
            }
        });

        setConsentValues(next);
    }, [userInfo, consentConfig]);

    useEffect(() => {
        if (first_name && first_name.length > 0) {
            setFirst_nameDisable(false);
        } else {
            setFirst_nameDisable(true);
        }
    }, [first_name]);
    const handleFirstName = (e: any) => {
        const input = e.target.value;
        const regex = /^[A-Za-z ]*$/;

        if (!regex.test(input)) return;
        if (input.startsWith(' ')) return;
        setFirst_name(input);
        setDisableBtn(false);
    }
    const handleSetPhon = (e: any) => {
        const { value } = e.target;
        if (value.length <= NUMBERS_LIMIT) {
            setPhone_number(value);
        }
        if (!checkPhone(value)) return;
        if (value.length == NUMBERS_LIMIT) {
            setPhoneDisable(false);
            setDisableBtn(false);
        }
        if (value.length < NUMBERS_LIMIT) {
            setPhoneDisable(true);
            setDisableBtn(true);
        }
    };
    const handleImage = (e: any) => {
        // const allowedTypes = ["image/jpeg", "image/png"];
        //  if (!allowedTypes.includes(e.target.files[0].type)) {
        //     toast.error("Only JPG and PNG image formats are allowed.", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 });
        //     return;
        // }
        //var size = 1e6; 1mb
        var size = 500e3
        if (e.target.files[0].size > size) {
            toast.error(t("IMAGE_UPLOAD_ERROR"), { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 })
        }
        else {
            const file = e.target.files[0]
            setProfilePic(file)
            // Create a persistent data URL so other screens (e.g., settings) can show preview immediately
            try {
                const reader = new FileReader();
                reader.onload = () => {
                    const dataUrl = String(reader.result || "");
                    if (dataUrl) {
                        setPreviewUrl(dataUrl)
                        try { sessionStorage.setItem('profilePreview', dataUrl) } catch (_e) { }
                    }
                };
                reader.readAsDataURL(file);
            } catch (error) { console.log(error) }

            toast.success(t("IMAGE_UPLOAD_SUCCESS"), { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 })
            setDisableBtn(false)
        }
    }
    useEffect(() => {
        if (!profilePic) {
            setPreviewUrl(null)
            return;
        }
        if (typeof profilePic === 'string') {
            const src = profilePic.startsWith("https://") ? profilePic : IMAGE_URL + profilePic;
            setPreviewUrl(src)
            return;
        }
        // If previewUrl already set from FileReader, keep it; else create object URL as fallback
        if (!previewUrl) {
            try {
                const url = URL.createObjectURL(profilePic)
                setPreviewUrl(url)
                return () => {
                    URL.revokeObjectURL(url)
                }
            } catch (_) {
                setPreviewUrl(null)
            }
        }
    }, [profilePic])
    const handleUpdateProfile = () => {

        if (!first_name) {
            setFirst_nameDisable(true)
        }

        const data = new FormData()
        const obj: any = {
            first_name,
            last_name: "",
            email_address,
            phone_number: `${PHONE_CODE}-` + phone_number,
            login_name: first_name,
            gender: gender,
            customer_birthday: date,
        };
        if (typeof consentValues.send_email !== 'undefined') obj.send_email = consentValues.send_email;
        if (typeof consentValues.send_pn !== 'undefined') obj.send_pn = consentValues.send_pn;
        if (typeof consentValues.send_sms !== 'undefined') obj.send_sms = consentValues.send_sms;
        if (typeof consentValues.check_policy !== 'undefined') obj.check_policy = consentValues.check_policy;
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
        data.append("body", encryptedData)

        // Only send a file if the user selected a new image
        if (profilePic instanceof File) {
            data.append("file", profilePic)
        }

        updateProfileData(customer_id, data, history, setDisableBtn)
    }
    const handleEmailChange = (e: any) => {
        const input = e.target.value;
        setEmail_address(e.target.value);

        // Email validation check
        const emailRegex = /^\S+@\S+\.\S+$/;
        setEmailError(!emailRegex.test(input));
        setDisableBtn(false)

    };
    const handleGender = (e: any) => {
        setGender(e.target.value)
        if (!e.target.value) {
            setGenderDisable(true)
            setDisableBtn(true);
        }
        else {
            setGenderDisable(false)
            setDisableBtn(false);
        }
    }
    const handleDate = (e: any) => {
        const selectedDate = e.target.value;
        const currentDate = new Date().toISOString().split('T')[0];

        if (selectedDate <= currentDate) {
            setDate(selectedDate);
            setDateDisable(false)
            setDisableBtn(false);
        } else {
            toast.error(t("FUTURE_DATE_ERROR"));
            setDate("");
            setDateDisable(true)
        }
    }

    useEffect(() => {
        if (!first_name) setFirst_nameDisable(true);
        if (!gender) setGenderDisable(true)
        if (!userInfo?.customer_birthday) setDateDisable(true)

    }, [first_name, gender, userInfo?.customer_birthday])

    const handleSubmit = () => {
        const originalFormattedPhone = phone?.split("-")[1] || "";
        if (originalFormattedPhone !== phone_number) {
            props.sendOtp({ phone_number: `${PHONE_CODE}-` + phone_number }, setShow);
            return;
        }
        handleUpdateProfile();
    }
    const handleVerify = () => {
        const data = new FormData()
        const obj: any = {
            first_name,
            last_name: "",
            email_address,
            phone_number: `${PHONE_CODE}-` + phone_number,
            login_name: first_name,
            gender: gender,
            customer_birthday: date,
        };
        if (typeof consentValues.send_email !== 'undefined') obj.send_email = consentValues.send_email;
        if (typeof consentValues.send_pn !== 'undefined') obj.send_pn = consentValues.send_pn;
        if (typeof consentValues.send_sms !== 'undefined') obj.send_sms = consentValues.send_sms;
        if (typeof consentValues.check_policy !== 'undefined') obj.check_policy = consentValues.check_policy;
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
        data.append("body", encryptedData)

        // Only send a file if the user selected a new image
        if (profilePic instanceof File) {
            data.append("file", profilePic)
        }

        const otpData = {
            phone_number: `${PHONE_CODE}-` + phone_number,
            otp: otp,
        }
        props.editProfileverifyOtp(otpData, data, customer_id, setDisableBtn, setShow)
    }

    useEffect(() => {
        if (otp.length >= 4) {
            handleVerify();
            setVerifyDisable(false)
        }
        else {
            setVerifyDisable(true);
        }
    }, [otp])

    const mandatoryConsentOkProfile = () => {
        for (const key of Object.keys(consentConfig) as ConsentKey[]) {
            if (consentConfig[key]?.mandatory && !consentValues[key]) return false;
        }
        return true;
    };

    const isSaveDisabled = (
        !first_name ||
        !email_address ||
        !gender ||
        emailError ||
        phoneError ||
        !checkPhone(phone_number) ||
        !mandatoryConsentOkProfile()
    );


    return (
        <>
            <Header />
            <div className='container profile-title mt-120 mb-5 text-center position-relative'>
                <div className="back-btn-position web-backbtn">
                    <GoBack />
                </div>
                <h2>{t("MY_DETAILS")}</h2>
                <p>{t("EDIT_DETAILS_SUBTEXT")}</p>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <div className='profile-update m-auto'>
                        <Button className='bg-theme' variant="contained" component="label" color='error'>
                            {t("UPLOAD")}
                            <input onChange={handleImage} hidden type="file" />
                        </Button>
                        {
                            previewUrl ? (
                                <img src={previewUrl} alt="profile pic" crossOrigin='anonymous' />
                            ) : userInfo.profile_pic ? (
                                    <img src={userInfo.profile_pic.startsWith("https://") ? userInfo.profile_pic : IMAGE_URL + userInfo.profile_pic} alt="profile pic" crossOrigin='anonymous' />
                            ) : (
                                < AccountCircleSharpIcon className='profile-link profile-img' />
                                )
                        }
                    </div>
                </Stack>
                <div className="row detail-info-update">
                    <div className="col-md-6 mt-3">
                        <TextField value={first_name}
                            onChange={(e) => {
                                handleFirstName(e)
                            }}
                            helperText={first_nameDisable ? "This is required Field" : ""}
                            className='field-style' id="filled-basic" label={`${t("FULL_NAME")} *`} variant="filled" color="error" />
                    </div>
                    <div className="col-md-6 mt-3">
                        <TextField
                            helperText={emailError ? t("INVALID_EMAIL") : ""}
                            type='email' value={email_address} onChange={handleEmailChange} className='field-style' id="filled-basic" label={`${t("EMAIL")} *`} variant="filled" color="error" />
                    </div>
                    <div className="col-md-6 mt-3">
                        <TextField
                            InputProps={{
                                startAdornment: <InputAdornment className='number-field' position="start">{PHONE_CODE}</InputAdornment>,
                            }}
                            helperText={phoneError ? t("PHONE_ERROR", { limit: NUMBERS_LIMIT }) : ""}
                            value={phone_number} type='number' onChange={handleSetPhon} className='field-style' id="filled-basic" label={`${t("PHONE_NUMBER")} (${MOBILE_STARS}) *`} variant="filled" color="error" />
                    </div>
                    <div className="col-md-6 mt-3">
                        <FormControl className='field-style' variant="filled" color="error">
                            <InputLabel id="demo-simple-select-filled-label">{t("GENDER")} *</InputLabel>
                            <Select
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                name="store_id"
                                value={gender}
                                onChange={handleGender}
                                className='field-style'
                            >

                                <MenuItem value={"Male"}>{t("MALE")}</MenuItem>
                                <MenuItem value={"Female"}>{t("FEMALE")}</MenuItem>
                                <MenuItem value={"Others"}>{t("OTHERS")}</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-6 mt-3">
                        <TextField type='date'
                            InputLabelProps={{
                                shrink: true,
                            }}

                            value={date}
                            onChange={handleDate}
                            name="dob"
                            className='field-style' id="filled-basic"
                            label="Date of Birth"
                            variant="filled"
                            color="error" />
                    </div>
                    <div className="col-md-12 mt-3">
                        <ConsentCheckboxesProfile
                            values={consentValues}
                            onChange={setConsentValues}
                            config={consentConfig}
                            privacyPolicyUrl={`privacy-policy`}
                        />
                    </div>
                    {userInfo?.is_active == 1 && <div className="col-md-12 mt-3">
                        <Button
                            disabled={isSaveDisabled}
                            onClick={handleSubmit}
                            className={` ${isSaveDisabled ? "disable-btn" : "able-btn"}`} variant="contained" color="error">{t("SAVE")}
                        </Button>
                    </div>}
                    {/* <div className="col-md-6 mt-3">
                    <TextField className='field-style' id="filled-basic" label="PASSWORD" variant="filled" color="error" />
                </div>
                <div className="col-md-6 mt-3">
                    <TextField className='field-style' id="filled-basic" label="NEW PASSWORD" variant="filled" color="error" />
                </div> */}

                </div>
            </div>

            <Modal
                className="payment-modal"
                show={show}
                onHide={() => setShow(false)}
                centered
            >
                <div className="modal-design">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Modal.Header
                    className="justify-content-center"
                    closeButton
                >
                    <h5 className='font-bold'>{t("VERIFY_OTP")}</h5>
                </Modal.Header>

                <Modal.Body className='w-100 delivery-order'>
                    <OtpModal otp={otp} setOtp={setOtp} phone_number={`${PHONE_CODE}-` + phone_number} />
                    <div className='d-flex justify-content-between gap-10'>
                        <div className="w-100">
                            <Button
                                disabled={verifyDisable}
                                onClick={handleVerify} className={`w-50 m-auto d-flex mt-4 mb-2 ${verifyDisable ? "disable-btn" : "able-btn"}`} variant="contained" color="error">{t("VERIFY")}</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <div className="edit-profile-footer">
                <Footer />
            </div>
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        updateProfileData: function (id: any, formData: any, history?: any, setState?: any) {
            dispatch(updateProfileData(id, formData, history, setState));
        },
        sendOtp: function (data: any, setShow: any) {
            dispatch(sendOtp(data, setShow))
        },
        editProfileverifyOtp: function (otpData: any, data: any, customer_id: any, setDisableBtn: any, setShow: any) {
            dispatch(editProfileverifyOtp(otpData, data, customer_id, setDisableBtn, setShow))
        },
        getProfile: (id: any) => {
            dispatch(getProfile(id, null, null, null, null, true));
        },
        saveCustomerInfo: () => {
            dispatch(saveCustomerInfo());
        },
        getConsentConfig: (langCode?: string) => dispatch(getConsentConfig(langCode)),
    }
}
export default connect(null, mapDispatchToProps)(MyDetail);
